import * as React from 'react';
import styled from 'styled-components';
import { appHeaderHeight, pageContentMaxWidth, tabletPortraitMinWidth, whiteColour } from '../../../cssConstants';

const PublicContent = ({ children }: Props) => {
	return <ContentWrapper>{children}</ContentWrapper>;
};

interface Props {
	children: React.ReactNode;
}

export default PublicContent;

const ContentWrapper = styled.section`
	background-color: ${whiteColour};
	margin: auto;
	max-width: ${pageContentMaxWidth};
	min-height: 100vh;

	@media (min-width: ${tabletPortraitMinWidth}) {
		min-height: ${`calc(100vh - 80px - ${appHeaderHeight})`};
	}
`;
